import { render, staticRenderFns } from "./PercentProp.vue?vue&type=template&id=4c479f36&scoped=true"
import script from "./PercentProp.vue?vue&type=script&lang=js"
export * from "./PercentProp.vue?vue&type=script&lang=js"
import style0 from "./PercentProp.vue?vue&type=style&index=0&id=4c479f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c479f36",
  null
  
)

export default component.exports